import { styled } from "@linaria/react";
import { ContentContainer } from "@/styles/utils/StyledGrid";
export const StyledEmptyEntries = /*#__PURE__*/styled(ContentContainer)({
  name: "StyledEmptyEntries",
  class: "StyledEmptyEntries_suqen79"
});

require("./StyledEmptyEntries.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./StyledEmptyEntries.tsx");